<div class="title-panel">
    {{title}}
</div>
<mat-divider></mat-divider>
<div class="info" *ngIf="subtitle!=null">
    {{subtitle}}
</div>
<mat-divider></mat-divider>
<div class="vertical-space"></div>
<form [formGroup]="formGroup" class="panel-list-item-form"> 
    <div class="keyvalue-properties-content">
        <div class="keyvalue-properties-content-keyvalue">Informações</div>
        <div class="keyvalue-properties-selection">
            <mat-form-field  appearance="outline" >
                <mat-label>Chave</mat-label>
                <input matInput #key
                       [matAutocomplete]="autoKey"
                       [formControl]="keyCtrl">
                <mat-autocomplete #autoKey="matAutocomplete" (optionSelected)="onkeyvalueKeySelected($event)">
                  <mat-option *ngFor="let key of filteredKeyOptions | async" [value]="key">
                    <span>{{key}}</span>
                  </mat-option>
                </mat-autocomplete>
            </mat-form-field>
            <mat-form-field  appearance="outline">
                <mat-label>Valor</mat-label>
                <input matInput #value
                       [matAutocomplete]="autoValue"
                       [formControl]="valueCtrl">
                <mat-autocomplete #autoValue="matAutocomplete">
                  <mat-option *ngFor="let value of filteredValueOptions | async" [value]="value">
                    <span>{{value}}</span>
                  </mat-option>
                </mat-autocomplete>
            </mat-form-field>
            <button mat-icon-button color="primary" aria-label="Confirmar Configuracao" (click)="addKeyUpkeyvalue(key.value,value.value);key.value='';value.value=''"> 
                <mat-icon>check</mat-icon>
            </button>
        </div>
        <div class="chip-keyvalue-panel">
            <mat-chip-listbox>
                <mat-chip-option *ngFor="let prop of formArray.controls"
                    selected="true"
                    [value]="prop"
                    [removable]="true"
                    (removed)="removeValue(prop)">
                    {{prop.value}}
                    <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip-option>
            </mat-chip-listbox>
        </div>
    </div>
</form>